// One join-token per room, stored under a room-scoped key so a student who
// has joined multiple rooms over time (different class periods) doesn't
// collide, and clearing one room's token never affects another's.

function storageKey(roomCode) {
  return `liveClassroom:playerToken:${String(roomCode).toUpperCase()}`;
}

function profileKey(roomCode) {
  return `liveClassroom:playerProfile:${String(roomCode).toUpperCase()}`;
}

export function loadSavedPlayer(roomCode) {
  try {
    const token = localStorage.getItem(storageKey(roomCode));
    if (!token) return null;
    const profileRaw = localStorage.getItem(profileKey(roomCode));
    let profile = {};
    if (profileRaw) {
      try {
        profile = JSON.parse(profileRaw);
      } catch {
        profile = {};
      }
    }
    const nickname = profile.nickname || profile.name || '';
    const avatar = profile.avatar || 'code';
    return {
      token,
      nickname,
      avatar,
      profile: { nickname, avatar, ...profile },
    };
  } catch {
    return null;
  }
}

export function savePlayer(roomCode, token, profile) {
  try {
    localStorage.setItem(storageKey(roomCode), token);
    const data = typeof profile === 'object' && profile !== null ? profile : { nickname: profile };
    localStorage.setItem(profileKey(roomCode), JSON.stringify(data));
  } catch {
    // localStorage unavailable (private mode etc.) - reconnect-by-name still works
  }
}

export function clearSavedPlayer(roomCode) {
  try {
    localStorage.removeItem(storageKey(roomCode));
    localStorage.removeItem(profileKey(roomCode));
  } catch {
    /* no-op */
  }
}
